import { Component, OnInit } from '@angular/core';
import { of } from 'rxjs';
import { NgWizardConfig, NgWizardService, StepChangedArgs, StepValidationArgs, STEP_STATE, THEME } from 'ng-wizard';
import { ActivatedRoute, Router } from '@angular/router';
import { type } from 'os';

@Component({
  selector: 'app-scheme-setup',
  templateUrl: './scheme-setup.component.html',
  styleUrls: ['./scheme-setup.component.scss']
})
export class SchemeSetupComponent implements OnInit {

  createSchemeFlag: boolean = true
  colifireWhitelistingFlag: boolean = false;
  whiteListFlag: boolean = false
  schemeId: any = 0
  schemeConfig: any = {}

  stepStates = {
    normal: STEP_STATE.normal,
    disabled: STEP_STATE.disabled,
    error: STEP_STATE.error,
    hidden: STEP_STATE.hidden
  };

  type2config: NgWizardConfig = {
    selected: 0,
    theme: THEME.arrows,
    toolbarSettings: {
      toolbarExtraButtons: [
        // { text: 'Finish', class: 'btn btn-info', event: () => { alert("Finished!!!"); } }
      ],
    }
  };
  showPreviousStep(event?: Event) {
    this.ngWizardService.previous();
  }

  showNextStep(event?: Event) {
    this.ngWizardService.next();
  }

  resetWizard(event?: Event) {
    this.ngWizardService.reset();
  }

  setTheme(theme: THEME) {
    this.ngWizardService.theme(theme);
  }

  stepChanged(args: StepChangedArgs) {
    console.log(args.step);
  }

  isValidTypeBoolean: boolean = true;

  isValidFunctionReturnsBoolean(args: StepValidationArgs) {
    return true;
  }

  isValidFunctionReturnsObservable(args: StepValidationArgs) {
    return of(true);
  }


  config: NgWizardConfig = {
    selected: 0, //default selected value
    theme: THEME.arrows,
    toolbarSettings: {}
  };


  constructor(
    private ngWizardService: NgWizardService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {

  }

  ngOnInit() {
    this.schemeConfig = JSON.parse(localStorage.getItem('scheme_config'))
    this.schemeId = this.activatedRoute.snapshot.paramMap.get("id")
    if (this.schemeId != 0) {
      this.setSteps()
    }
    else if (this.schemeConfig.scheme_id != '' && this.schemeConfig.scheme_id != null && this.schemeConfig.scheme_id != undefined) {
      this.setSteps()
    }
  }

  setSteps() {
    debugger
    if (this.schemeConfig.create && !this.schemeConfig.whitelist) {
      this.createScheme(true)
    } else if (this.schemeConfig.whitelist && !this.schemeConfig.colifire_whitelist) {
      this.createScheme(true)
      this.whiteListData(true)
    } else if (this.schemeConfig.colifire_whitelist) {
      this.createScheme(true)
      this.whiteListData(true)
      this.colifireWhitelisting(true)
    }
  }

  createScheme(event) {
    console.log("create ", event)
    this.whiteListFlag = true
    setTimeout(() => {
      this.ngWizardService.next();
    }, 100)
  }

  whiteListData(event) {
    console.log("white list", event)
    this.colifireWhitelistingFlag = true
    setTimeout(() => {
      this.ngWizardService.next();
    }, 100)
  }

  colifireWhitelisting(event) {
    console.log("white list", event)
    setTimeout(() => {
      this.ngWizardService.next();
    }, 100)
  }

  createSchemeDetail(event) {
    this.schemeId = event.scheme_id
    this.createScheme(event.schecme_created)
  }



}
